import { PublicKey } from '@solana/web3.js';

import type { AddSolanaPairRequest } from 'entities/project/api/project/api.types';

export type SolanaPairFormValues = {
  poolAddress: string;
};

export type SolanaPairFormErrors = Partial<Record<keyof SolanaPairFormValues, string>>;

export const initialSolanaPairFormValues: SolanaPairFormValues = {
  poolAddress: '',
};

const isCanonicalSolanaAddress = (value: string): boolean => {
  try {
    return new PublicKey(value).toBase58() === value;
  } catch {
    return false;
  }
};

export const validateSolanaPairForm = (values: SolanaPairFormValues): SolanaPairFormErrors => {
  const errors: SolanaPairFormErrors = {};
  const poolAddress = values.poolAddress.trim();

  if (!isCanonicalSolanaAddress(poolAddress)) {
    errors.poolAddress = 'Enter a canonical Solana address';
  }
  return errors;
};

export const toAddSolanaPairRequest = (
  projectId: number,
  dex: AddSolanaPairRequest['dex'],
  values: SolanaPairFormValues,
): AddSolanaPairRequest => {
  return {
    projectId,
    dex,
    pool_address: values.poolAddress.trim(),
  };
};
